"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StepLabelComponent;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _material.styled)('div')(({
  theme,
  ownerState: {
    active,
    completed
  }
}) => ({
  backgroundColor: active === true || completed === true ? theme.palette.primary.main : theme.palette.grey[200],
  zIndex: 1,
  fontSize: '1.8rem',
  fontWeight: 'bold',
  color: active === true || completed === true ? theme.palette.primary.contrastText : theme.palette.text.secondary,
  width: 38,
  height: 38,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center'
}));
function StepLabelComponent({
  completed,
  active,
  icon
}) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Root, {
    className: "MuiOriStepLabelComponent",
    ownerState: {
      completed,
      active
    },
    children: icon
  });
}
